export default __webpack_public_path__ + "static/media/Opposites03_00.b73dac56.png";